import React from 'react';
import { Avatar, Typography } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import './UserMenuHeader.css';

export interface UserMenuHeaderProps {
  name: string;
  email: string;
  avatarUrl?: string;
}

/**
 * UserMenuHeader
 *
 * Displays user name, email, and avatar at the top of the user menu popover.
 * Read-only header with no interaction.
 */
export const UserMenuHeader: React.FC<UserMenuHeaderProps> = ({
  name,
  email,
  avatarUrl,
}) => (
  <div className="user-menu-header" data-testid="user-menu-header">
    <Avatar
      src={avatarUrl}
      icon={!avatarUrl && <UserOutlined />}
      size={40}
      className="user-menu-header__avatar"
      alt={name}
    />
    <div className="user-menu-header__info">
      <Typography.Text strong className="user-menu-header__name">
        {name}
      </Typography.Text>
      <Typography.Text type="secondary" className="user-menu-header__email">
        {email}
      </Typography.Text>
    </div>
  </div>
);

export default UserMenuHeader;
